import React from "react";
import { browserHistory } from "react-router";
import { Link } from "react-router";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import LoadingIndicatorHeader from "../loading-indicator/loading-indicator-header";
import ScheduleByDayTitle from "./schedule-by-day-title";
import moment from "moment";
import util from "../util/util";

export default function ScheduleByDayButtons(props) {
  const yesterday = returnDay(props.day, -1, util.dateFormatComputer);
  const tomorrow = returnDay(props.day, 1, util.dateFormatComputer);

  return (
    <div className="row">
      <div className="col-sm-6 col-sm-push-3 text-center">
        {props.loaded === false ? (
          <LoadingIndicatorHeader />
        ) : (
          <div className="datepicker__container">
            <DatePicker
              customInput={
                <ScheduleByDayTitle
                  dayDisplay={returnDay(props.day, 0, `dddd, MMM D, YYYY`)}
                />
              }
              selected={moment(props.day)}
              onChange={value => {
                const newDay = value.format(util.dateFormatComputer);
                const newUrl = util.returnScheduleDayUrl(newDay);

                browserHistory.push(newUrl);
              }}
            />
          </div>
        )}
      </div>

      <div className="col-xs-6 col-sm-3 col-sm-pull-6">
        <p className="page__actions page__actions--prev">
          <Link
            className="btn btn-default"
            to={util.returnScheduleDayUrl(yesterday)}
          >
            <i className="fa fa-arrow-left" aria-hidden="true"></i>
            {moment(yesterday).format(util.dateFormatRangeShort)}
          </Link>
        </p>
      </div>

      <div className="col-xs-6 col-sm-3">
        <p className="page__actions page__actions--next">
          <Link
            className="btn btn-default"
            to={util.returnScheduleDayUrl(tomorrow)}
          >
            {moment(tomorrow).format(util.dateFormatRangeShort)}
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </Link>
        </p>
      </div>
    </div>
  );

  // convert one date (string) into another date (string);
  function returnDay(day, dayOffset, dateFormat) {
    const date = moment(day);

    return date.add(dayOffset, `days`).format(dateFormat);
  }
}

ScheduleByDayButtons.propTypes = {
  day: PropTypes.string, // used to generate title and links;
  loaded: PropTypes.bool // has the schedule data loaded or not;
};
